import { reduxForm } from 'redux-form';
import Component from './ApproveManualActivation';
import { validate, initialValues } from './schema';

const ApproveManualActivation = reduxForm({
  form: 'formApproveManualActivation',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default ApproveManualActivation;
